module.exports = __webpack_public_path__ + "img/calendar.824b33c7.svg";